import { render, staticRenderFns } from "./downloadApp_jd.vue?vue&type=template&id=78db6a95&scoped=true"
import script from "./downloadApp_jd.vue?vue&type=script&lang=js"
export * from "./downloadApp_jd.vue?vue&type=script&lang=js"
import style0 from "./downloadApp_jd.vue?vue&type=style&index=0&id=78db6a95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78db6a95",
  null
  
)

export default component.exports